import { render, staticRenderFns } from "./revokeOrder.vue?vue&type=template&id=3b548704&scoped=true&"
import script from "./revokeOrder.vue?vue&type=script&lang=js&"
export * from "./revokeOrder.vue?vue&type=script&lang=js&"
import style0 from "./revokeOrder.vue?vue&type=style&index=0&id=3b548704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b548704",
  null
  
)

export default component.exports